module.exports = __webpack_public_path__ + "img/jianjie (2).a34ab9eb.png";